<template>
  <button
    class="w-full lg:w-auto"
    :class="buttonStyleClass"
    :form="form"
    @click="handleClick"
  >
    <ButtonLoading :loading="loading">{{ message }}</ButtonLoading>
  </button>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import ButtonLoading from "../ui/ButtonLoading.vue";

export default {
  name: "ProductAddToCartForm",

  components: { ButtonLoading },

  props: {
    variant: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    quantity: {
      type: Number,
      default: 1,
    },
    form: {
      type: String,
      default: "",
    },
    messageReversed: {
      type: Boolean,
      default: false,
    },
    buttonStyle: {
      type: String,
      default: "",
    },
  },

  computed: {
    isEnabled() {
      return this.variant && this.variant.isAvailable;
    },

    buttonStyleClass() {
      return this.buttonStyle
        ? `btn-${this.buttonStyle} min-h-10`
        : "btn-strong";
    },

    message() {
      if (this.isEnabled) {
        return this.messageReversed
          ? `Add to cart - $${this.variant.salePrice} ${
              this.quantity > 1 ? `x${this.quantity}` : ""
            }`
          : `$${this.variant.salePrice} ${
              this.quantity > 1 ? `x${this.quantity}` : ""
            } - Add To Cart`;
      }
      return "Add to cart";
    },
  },

  methods: {
    ...mapActions("cart", ["addItem"]),
    ...mapMutations(["openSiteCart"]),

    handleClick() {
      if (!this.isEnabled) {
        return;
      }
      this.addItem({
        purchasable: this.variant,
        quantity: this.quantity,
        options: null,
      });
      this.openSiteCart();
    },
  },
};
</script>
